/**
 * Configuration API service
 * Handles fetching dynamic configuration from the backend
 */

import apiClient from '../utils/apiClient';

// Types for field configuration
export interface FieldOption {
  value: string;
  label: string;
  description?: string;
}

export interface FieldDefinition {
  name: string;
  label: string;
  question: string;
  description?: string;
  type: 'select' | 'text' | 'radio' | 'checkbox' | 'multiselect';
  options: FieldOption[];
  default_value: string | string[];
  required: boolean;
  depends_on?: string;
  depends_on_value?: string | string[];
  hierarchy_mapping?: Record<string, string[]>;
  respondent?: 'live' | 'post_session' | 'system';
  conditional_logic?: {
    auto_fill?: {
      when: Record<string, string>;
      value: string;
    };
  };
}

export interface FieldsConfig {
  use_case_type: string;
  version: string;
  field_order: string[];
  fields: Record<string, FieldDefinition>;  // field_name -> FieldDefinition mapping
  question_map: Record<string, string>;  // Backward compatibility - field name to question text mapping
}

export const configService = {
  /**
   * Fetch field configuration for dynamic form rendering
   * Includes question_map for backward compatibility
   */
  async fetchFieldsConfig(useCase: string = 'incident_report'): Promise<FieldsConfig> {
    const response = await apiClient.get(`/api/config/fields?use_case_type=${useCase}`);
    return response.data;
  },
};
